<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/transmission.svg" />
          </div>
          <div>
            <div class="card_title_1">NETWORK</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
        <!-- <div class="card-header-right" style="top: 0px">
          <div class="input-group">
            <span class="input-group-text" style="background-color: #e6e6e6"
              ><i class="fa fa-search"></i
            ></span>
            <input
              class="form-control"
              style="background-color: #e6e6e6; font-size: 12px; width: 200px"
              type="text"
              placeholder="Search Province, Kabupaten"
            />
          </div>
        </div> -->
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <CardWhite
            v-if="network.length > 0"
            :param="network[0]"
            :height="150"
            :selected="selectedCard === network[0]"
            @click="selectCard(network[0])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 0"
            :param="network[1]"
            :height="150"
            :selected="selectedCard === network[1]"
            @click="selectCard(network[1])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 0"
            :param="network[2]"
            :height="150"
            :selected="selectedCard === network[2]"
            @click="selectCard(network[2])"
          ></CardWhite>

          <CardWhite
            v-if="network.length > 0"
            :param="network[3]"
            :height="150"
            :selected="selectedCard === network[3]"
            @click="selectCard(network[3])"
          ></CardWhite>
        </div>
        <div class="col-9">
          <h5 style="text-transform: uppercase" class="m-0">
            {{ titleNetwork }}
          </h5>
          <!--<img
            style="width: 100%"
            src="@/assets/images/indonesia-rasio-desa-berlistrik.png"
          />-->
          <div v-if="isMap">
            <l-map
              :zoom="simple.zoom"
              :center="simple.center"
              style="height: 500px; z-index: 0"
              :zoomControl="false"
              :dragging="false"
              :options="simple"
            >
              <l-tile-layer :url="simple.url"></l-tile-layer>
              <l-marker
                v-for="(marker, id) in dataMap"
                :key="id"
                :lat-lng="marker.latLng"
                :icon="simple.iconBlue"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  {{ marker.provinceName }}
                  <br />
                  {{ formattedNumber(marker.value) }}
                </l-tooltip>
              </l-marker>
            </l-map>
          </div>

          <div v-if="isMap" class="row">
            <div class="d-flex align-items-end">
              <div
                style="
                  font-size: 42px;
                  font-weight: 400;
                  line-height: 50.83px;
                  color: #4d4d4d;
                  margin-right: 32px;
                "
              >
                {{ networkDetailRasio.totalValue }} %
              </div>
              <div style="margin-right: 32px">
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    letter-spacing: 0.02em;
                    color: #7e7e7e;
                  "
                >
                  Sem 1 Target
                </div>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16.41px;
                    letter-spacing: 0.02em;
                    color: #000000;
                  "
                >
                  {{ networkDetailRasio.totalFirstSemesterTarget }} %
                </div>
              </div>
              <div style="margin-right: 32px">
                <div
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    letter-spacing: 0.02em;
                    color: #7e7e7e;
                  "
                >
                  Sem 2 Target
                </div>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 16.41px;
                    letter-spacing: 0.02em;
                    color: #000000;
                  "
                >
                  {{ networkDetailRasio.totalSecondSemesterTarget }} %
                </div>
              </div>
              <div
                v-for="(item, id) in networkDetailRasio.items"
                :key="id"
                style="
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #7e7e7e;
                  margin-right: 10px;
                "
              >
                {{ item.instanceName }}
                <span style="color: #00aa4e">{{ item.value }} %</span>
              </div>
              <!-- <div
                style="
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #00aa4e;
                  margin-right: 4px;
                "
              >
                100%
              </div>
              <div
                style="
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #7e7e7e;
                  margin-right: 4px;
                "
              >
                JAMALI
              </div>
              <div
                style="
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #00aa4e;
                  margin-right: 4px;
                "
              >
                100%
              </div>
              <div
                style="
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #7e7e7e;
                  margin-right: 4px;
                "
              >
                SULMAPANA
              </div>
              <div
                style="
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 14.06px;
                  letter-spacing: 0.02em;
                  color: #00aa4e;
                  margin-right: 4px;
                "
              >
                99.50%
              </div> -->
            </div>
          </div>
          <div v-if="isMap" class="progress mt-2">
            <div
              class="progress-bar bg-success"
              role="progressbar"
              style="width: 99.5%"
              aria-valuenow="49.85"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <div v-else>
            <div class="m-t-10 d-flex justify-content-between">
              <div>
                <span
                  class="text-detail m-r-25"
                  :class="{ 'area-tab-selected': selectedTab === 'reg_opdis' }"
                  @click="selectTab('reg_opdis')"
                >
                  All
                </span>
                <span
                  class="text-detail m-r-25"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_sumkal',
                  }"
                  @click="selectTab('reg_opdis_sumkal')"
                >
                  Sumatera & Kalimantan
                </span>
                <span
                  class="text-detail m-r-25"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_jamali',
                  }"
                  @click="selectTab('reg_opdis_jamali')"
                >
                  Jawa, Madura & Bali
                </span>
                <span
                  class="text-detail"
                  :class="{
                    'area-tab-selected': selectedTab === 'reg_opdis_sulmapana',
                  }"
                  @click="selectTab('reg_opdis_sulmapana')"
                >
                  Sulawesi, Papua, Maluku & Nusa Tenggara
                </span>
              </div>
              <div>
                <select v-model="uuid" class="custom-dropdown form-select">
                  <option
                    v-for="(option, key) in dataUuid"
                    :key="key"
                    :value="option.value"
                    :disabled="option.disabled"
                  >
                    {{ option.label }}
                  </option>
                  <!-- <option>Fix price</option> -->
                </select>
              </div>
            </div>
            <div class="card-body">
              <div>
                <span
                  :style="period === 'monthly' ? 'color:#16C7F9' : ''"
                  @click="selectPeriod('monthly')"
                  class="f-light m-r-10"
                  >Monthly</span
                >|<span
                  :style="period === 'quarterly' ? 'color:#16C7F9' : ''"
                  @click="selectPeriod('quarterly')"
                  class="f-light m-l-10 m-r-10"
                  >Quarterly</span
                >|<span
                  :style="period === 'yearly' ? 'color:#16C7F9' : ''"
                  @click="selectPeriod('yearly')"
                  class="m-l-10 m-r-10 f-light"
                  >Yearly</span
                >
              </div>
              <apexchart
                height="400"
                width="100%"
                type="line"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { latLng, icon } from "leaflet";

import { formattedNumber } from "@/utils/helper";
import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";
import CardWhite from "./CardWhite.vue";
import "leaflet/dist/leaflet.css";

const getRef = ReferenceService.build();
const apiDistribution = DistributionService.build();

export default {
  props: ["last_update", "data"],
  components: {
    IconSvg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    CardWhite,
  },
  data() {
    return {
      uuid: "default",
      dataUuid: [],
      period: "monthly",
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          toolbar: {
            show: false, // Hide toolbar
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%", // Adjust column width
          },
        },
        colors: [
          function ({ value, seriesIndex, dataPointIndex, w }) {
            const data = w.config.series;
            const item = data.filter((item) => item.type === "line");
            if (
              (data[1] && dataPointIndex == 10) ||
              (data[1] && dataPointIndex == 11)
            ) {
              return "#868e96";
            } else {
              return "#8099D9";
            }
          },
        ],
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Des",
          ],
        },
        yaxis: [
          // {
          //   title: {
          //     text: "Forecast",
          //   },
          // },
          // {
          //   opposite: true,
          //   title: {
          //     text: "Actual",
          //   },
          // },
        ],
        legend: {
          show: true,
          position: "top",
          labels: {
            // colors: ["#ff5151", "#8099D9", "#333"], // Define label colors
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: "#ff5151",
            radius: 12,
          },
        },
        stroke: {
          width: 3, // Set different line widths for line and column series
          curve: "smooth", // Smoothen the line series
        },
        markers: {
          size: 6, // Set the size of the markers
          colors: ["#ff5151"], // Set the color of the markers
          strokeWidth: 1, // Set the width of the markers' border
        },
      },
      series: [],
      isMap: true,
      dataNetwork: [],
      modalMap: {
        show: false,
        load: false,
      },
      titleNetwork: "",
      dataMap: [],
      simple: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        zoom: 5,
        center: [-1.8263233, 118.3522204],
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        iconBlue: icon({
          iconUrl: "map-marker-circle-blue.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
      },
      selectedTab: "reg_opdis",
      selectedCard: 0,
      network: [],
      networkDetailRasio: {},
      netorkDetailJaringan: {},
      idDetailMap: "",
    };
  },
  mounted() {
    this.getDataDistributionNetwork("");
    this.getRefUid();
  },
  methods: {
    async getRefUid() {
      const res = await getRef.getRefUid();
      const data = res.data.data;
      const defaults = {
        label: "Select UID",
        value: "default",
        disabled: true,
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    selectPeriod(period) {
      this.period = period;
      let params = {
        id: this.selectedCard.metricId,
        instance: this.selectedTab,
        period: period,
      };
      this.getDataDistributionNetworkDetailJaringan(params);
    },
    selectTab(tab) {
      this.selectedTab = tab;
      let params = {
        id: this.selectedCard.metricId,
        instance: tab,
        period: this.period,
      };
      this.getDataDistributionNetworkDetailJaringan(params);
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    clickMarker(x) {
      this.modalMap.show = true;
      this.dataNetwork = x;
    },
    selectCard(id) {
      this.selectedTab = "reg_opdis";
      this.idDetailMap = id.metricId;
      this.selectedCard = id;
      this.titleNetwork = id.metricName;
      let params = {
        id: id.metricId,
        province: "all",
        period: "monthly",
      };
      const found = id.metricId.includes("JT");
      if (found) {
        this.getDataDistributionNetworkDetailJaringan(params);
      } else {
        this.getDataDistributionNetworkDetailRasio(params);
      }
    },
    async getDataDistributionNetworkMap(data) {
      let param = Object.assign({
        metricId: data.id !== undefined ? data.id : data.metricId,
      });
      const res = await apiDistribution.getDataDistributionNetworkMap(param);
      if (res && res.status == 200) {
        const arrayOfObjects = res.data.data;
        arrayOfObjects.forEach((obj) => {
          obj.latLng = [parseFloat(obj.latitude), parseFloat(obj.longitude)]; // Add 'age' key with value 30 to each object
        });
        this.dataMap = arrayOfObjects;
      }
    },
    async getDataDistributionNetwork(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionNetwork(param);
      if (res && res.status == 200) {
        this.network = res.data.data;
        const param = {
          id: res.data.data[0].metricId,
        };
        this.selectCard(res.data.data[0]);
        this.getDataDistributionNetworkMap(param);
        this.getDataDistributionNetworkDetailRasio(param);
      }
    },

    async getDataDistributionNetworkDetailRasio(params) {
      let param = Object.assign({
        metricId: params.id,
      });
      const res = await apiDistribution.getDataDistributionNetworkDetailRasio(
        param
      );
      if (res && res.status == 200) {
        this.isMap = true;
        this.networkDetailRasio = res.data.data;
        this.getDataDistributionNetworkMap(param);
      }
    },

    async getDataDistributionNetworkDetailJaringan(params) {
      let param = Object.assign({
        metricId: params.id,
        instance: params.instance,
        period: params.period,
      });
      const res =
        await apiDistribution.getDataDistributionNetworkDetailJaringan(param);
      if (res && res.status == 200) {
        const data = res.data.data;
        const target = data.map((obj) => obj.target);
        const value = data.map((obj) => obj.value);
        const datas = [
          {
            color: "#ff5151",
            name: "Target",
            type: "line",
            data: target,
          },
          {
            color: "#8099D9",
            name: "Actual",
            type: "column",
            data: value,
          },
        ];
        this.series = datas;
        this.isMap = false;
        this.networkDetailJaringan = res.data.data;
      }
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.area-tab-selected {
  padding: 5px 10px;
  border-radius: 8px;
  background-color: #00a3e9;
  color: #fff;
}
</style>
